import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Trash2, Mail, Eye } from "lucide-react";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [view, setView] = useState(null);

  const load = () => api.get("/contact").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (m) => {
    if (!window.confirm("Mesaj silinsin mi?")) return;
    try {
      await api.delete(`/contact/${m.id}`);
      toast.success("Silindi");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const setStatus = async (m, status) => {
    try {
      await api.put(`/contact/${m.id}/status`, null, { params: { status } });
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <div className="wb-overline">Yönetim</div>
      <h1 className="wb-h2 mt-2">İletişim Mesajları</h1>

      <div className="wb-card mt-8 overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm">
          <thead>
            <tr className="border-b border-white/10 text-left text-[#a0aabf] text-xs uppercase tracking-widest">
              <th className="p-4">Gönderen</th>
              <th className="p-4">Konu</th>
              <th className="p-4">Durum</th>
              <th className="p-4">Tarih</th>
              <th className="p-4 text-right">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="5" className="p-8 text-center text-[#a0aabf]">Henüz mesaj yok.</td></tr>
            ) : items.map((m) => (
              <tr key={m.id} className="border-b border-white/5" data-testid={`row-contact-${m.id}`}>
                <td className="p-4">
                  <div>{m.name}</div>
                  <div className="text-xs text-[#a0aabf]">{m.email}</div>
                </td>
                <td className="p-4 max-w-xs">
                  <div className="text-[#d4af37]">{m.subject}</div>
                  <div className="text-xs text-[#a0aabf] line-clamp-1 mt-1">{m.message}</div>
                </td>
                <td className="p-4">
                  <select
                    value={m.status || "new"}
                    onChange={(e) => setStatus(m, e.target.value)}
                    className="bg-[#030f26] border border-white/10 text-xs px-2 py-1 text-white"
                  >
                    <option value="new">Yeni</option>
                    <option value="read">Okundu</option>
                    <option value="resolved">Çözüldü</option>
                  </select>
                </td>
                <td className="p-4 text-[#a0aabf] text-xs">{new Date(m.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-4 text-right space-x-2">
                  <button onClick={() => setView(m)} className="p-2 border border-white/10 hover:border-[#d4af37] hover:text-[#d4af37]" title="Görüntüle"><Eye size={14} /></button>
                  <a href={`mailto:${m.email}`} className="inline-block p-2 border border-white/10 hover:border-[#d4af37] hover:text-[#d4af37]" title="E-posta"><Mail size={14} /></a>
                  <button onClick={() => remove(m)} className="p-2 border border-white/10 hover:border-red-500 hover:text-red-400"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {view && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70" onClick={() => setView(null)}>
          <div className="bg-[#081b3d] border border-white/10 w-full max-w-xl p-8" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-serif text-xl">{view.subject}</h2>
            <div className="mt-2 text-xs text-[#a0aabf]">{view.name} · {view.email} · {view.phone || "-"}</div>
            <div className="mt-6 text-sm whitespace-pre-line">{view.message}</div>
            <div className="mt-8 flex justify-end gap-3">
              <a href={`mailto:${view.email}?subject=Re: ${view.subject}`} className="wb-btn-primary">Yanıtla</a>
              <button onClick={() => setView(null)} className="wb-btn-secondary">Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
